import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApplicationType } from './use-application-type';

export function useGoBackToPreviousFirstResponderPage(onGoBack?: () => void) {
    const navigate = useNavigate();
    const { isFirstResponder } = useApplicationType();
    const { state } = useLocation();

    return useCallback(
        () => {
            if (isFirstResponder) {
                onGoBack?.();

                // if a state.previousLocationPathname exists, use it to issue a navigation action
                // and pass along the state from a previous page
                if (state?.previousLocationPathname) {
                    navigate(state.previousLocationPathname, {
                        state: { ...state, previousLocationPathname: null },
                    });
                    // otherwise issue the delta navigation back to whatever previous page the user was on
                } else {
                    navigate(-1);
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isFirstResponder, state]
    );
}
